export default "__VITE_ASSET__D$4zKtC4__"